export default __webpack_public_path__ + "static/media/Camion7-t.9cff42fc.png";